/* eslint-disable react/prop-types */

/* eslint-disable prettier/prettier */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M694.9,332.3c0-52.3-67.3-163.8-106.3-223.9c-12.7-19.6-41.5-19.6-54.2,0c-39,60.2-106.3,171.6-106.3,223.9 c0,53.8,31.8,100.1,77.6,121.2c5.3,2.4,10.3-4,6.6-8.6c-8.9-10.9-14.3-24.9-14.3-40c0-24.9,32-77.8,50.5-106.4 c6-9.3,19.7-9.3,25.8,0C593,327,624.9,380,624.9,404.9c0,15.2-5.3,29.1-14.3,40c-3.7,4.5,1.3,11,6.6,8.6 C663.1,432.4,694.9,386.1,694.9,332.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M472.3,619.3c-0.2,40.4-30.7,73-68.2,72.8s-67.7-33.1-67.6-73.5c0.1-28.7,34.7-89.7,54.7-122.6 c6.5-10.7,21.2-10.7,27.6,0.1C438.4,529.3,472.4,590.6,472.3,619.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M560.7,418.5L560.7,418.5c-11.3,0-20.5,9.2-20.5,20.5v153.3c0,6.3,5.2,11.5,11.5,11.5h18 c6.3,0,11.5-5.2,11.5-11.5V439.1C581.3,427.8,572,418.5,560.7,418.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M512.4,991.1h104.8c69.7,0,126.8-57.1,126.8-126.8l0-288.1c0-51.8-44.2-92.6-95.8-88.7 c-26.1,2-54.1,3.1-83.4,3.1c-52.3,0-100.9-3.5-141-9.5c-20.1-3-38.2,12.7-38.2,33l0,350.2C385.5,934,442.6,991.1,512.4,991.1z"
})), 'CategoryRG', {
  viewBox: '0 0 1080 1080'
});